export const GOVERNI = [
    { label: "I Governo De Gasperi (dal 10/12/1945 al 13/07/1946)", id: "G055" },
    { label: "II Governo De Gasperi (dal 13/07/1946 al 02/02/1947)", id: "G056" },
    { label: "III Governo De Gasperi (dal 02/02/1947 al 31/05/1947)", id: "G057" },
    { label: "IV Governo De Gasperi (dal 31/05/1947 al 23/05/1948)", id: "G058" },
];

export const MEMBRI = [
[
  {
    "governo": "G058",
    "ruolo": "MINISTRO DEGLI AFFARI ESTERI",
    "idpersona": "PG0028500",
    "id": "G058 M0122 C00003 PG0028500",
    "cognome": "SFORZA",
    "nome": "Carlo"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELLA GRAZIA E GIUSTIZIA",
    "idpersona": "PG0011780",
    "id": "G058 M0125 C00003 PG0011780",
    "cognome": "GRASSI",
    "nome": "Giuseppe"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLE POSTE E TELECOMUNICAZIONI",
    "idpersona": "PG0011300",
    "id": "G058 M0116 C00005 PG0011300",
    "cognome": "DE VITA",
    "nome": "Francesco"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA PRESIDENZA DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0011350",
    "id": "G057 M0121 C00027 PG0011350",
    "cognome": "CAPPA",
    "nome": "Paolo"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO AL TESORO",
    "idpersona": "PG0012150",
    "id": "G056 M0072 C00005 PG0012150",
    "cognome": "PETRILLI",
    "nome": "Raffaele Pio"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'INTERNO",
    "idpersona": "PG0011320",
    "id": "G057 M0123 C00005 PG0011320",
    "cognome": "CARPANO MAGLIOLI",
    "nome": "Ernesto"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO AGLI AFFARI ESTERI",
    "idpersona": "PG0018060",
    "id": "G056 M0122 C00005 PG0018060",
    "cognome": "BRUSASCA",
    "nome": "Giuseppe"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DELL'AGRICOLTURA E FORESTE",
    "idpersona": "PG0026930",
    "id": "G057 M0078 C00003 PG0026930",
    "cognome": "SEGNI",
    "nome": "Antonio"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA PUBBLICA ISTRUZIONE",
    "idpersona": "PG0027300",
    "id": "G057 M0112 C00005 PG0027300",
    "cognome": "BERNINI",
    "nome": "Ferdinando"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA DIFESA",
    "idpersona": "PG0018060",
    "id": "G057 M0111 C00005 PG0018060",
    "cognome": "BRUSASCA",
    "nome": "Giuseppe"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'INDUSTRIA E COMMERCIO",
    "idpersona": "PG0010650",
    "id": "G056 M0117 C00005 PG0010650",
    "cognome": "TREMELLONI",
    "nome": "Roberto"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELLE FINANZE",
    "idpersona": "PG0019540",
    "id": "G058 M0109 C00003 PG0019540",
    "cognome": "PELLA",
    "nome": "Giuseppe"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DEI TRASPORTI",
    "idpersona": "PG0300645",
    "id": "G058 M0115 C00003 PG0300645",
    "cognome": "CORBELLINI",
    "nome": "Guido"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DEGLI AFFARI ESTERI",
    "idpersona": "PG0028500",
    "id": "G057 M0122 C00003 PG0028500",
    "cognome": "SFORZA",
    "nome": "Carlo"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DELLA DIFESA",
    "idpersona": "PG0027920",
    "id": "G057 M0111 C00003 PG0027920",
    "cognome": "GASPAROTTO",
    "nome": "Luigi"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'AGRICOLTURA E FORESTE",
    "idpersona": "PG0028530",
    "id": "G056 M0078 C00005 PG0028530",
    "cognome": "SPANO",
    "nome": "Velio"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO FINANZE E TESORO",
    "idpersona": "PG0012150",
    "id": "G057 M0107 C00005 PG0012150",
    "cognome": "PETRILLI",
    "nome": "Raffaele Pio"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO AL LAVORO E PREVIDENZA SOCIALE",
    "idpersona": "PG0020170",
    "id": "G057 M0099 C00005 PG0020170",
    "cognome": "TOGNI",
    "nome": "Giuseppe"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA DIFESA",
    "idpersona": "PG0013110",
    "id": "G058 M0111 C00005 PG0013110",
    "cognome": "CHATRIAN",
    "nome": "Luigi"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DELLA PUBBLICA ISTRUZIONE",
    "idpersona": "PG0018910",
    "id": "G057 M0112 C00003 PG0018910",
    "cognome": "GONELLA",
    "nome": "Guido"
  },
  {
    "governo": "G057",
    "ruolo": "ALTO COMMISSARIO PER L'ALIMENTAZIONE",
    "idpersona": "PG0018180",
    "id": "G057 M0149 C00031 PG0018180",
    "cognome": "CERRETI",
    "nome": "Giulio"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO AGLI AFFARI ESTERI",
    "idpersona": "PG0002930",
    "id": "G056 M0122 C00005 PG0002930",
    "cognome": "GIOLITTI",
    "nome": "Antonio"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DEL BILANCIO",
    "idpersona": "PG0027790",
    "id": "G058 M0108 C00003 PG0027790",
    "cognome": "EINAUDI",
    "nome": "Luigi"
  },
  {
    "governo": "G058",
    "ruolo": "VICEPRESIDENTE DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0027790",
    "id": "G058 M0121 C00002 PG0027790",
    "cognome": "EINAUDI",
    "nome": "Luigi"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DEL LAVORO E PREVIDENZA SOCIALE",
    "idpersona": "PG0200365",
    "id": "G058 M0099 C00003 PG0200365",
    "cognome": "FANFANI",
    "nome": "Amintore"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO FINANZE E TESORO",
    "idpersona": "PG0025460",
    "id": "G057 M0107 C00003 PG0025460",
    "cognome": "CAMPILLI",
    "nome": "Pietro"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DEL TESORO",
    "idpersona": "PG0007580",
    "id": "G056 M0072 C00003 PG0007580",
    "cognome": "CORBINO",
    "nome": "Epicarmo"
  },
  {
    "governo": "G057",
    "ruolo": "PRESIDENTE DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0013230",
    "id": "G057 M0121 C00001 PG0013230",
    "cognome": "DE GASPERI",
    "nome": "Alcide"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA PRESIDENZA DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0011350",
    "id": "G056 M0121 C00027 PG0011350",
    "cognome": "CAPPA",
    "nome": "Paolo"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DEL TESORO",
    "idpersona": "PG0027320",
    "id": "G056 M0072 C00003 PG0027320",
    "cognome": "BERTONE",
    "nome": "Giovanni Battista"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELLA DIFESA",
    "idpersona": "PG0027610",
    "id": "G058 M0111 C00003 PG0027610",
    "cognome": "CINGOLANI",
    "nome": "Mario"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA PUBBLICA ISTRUZIONE",
    "idpersona": "PG0027250",
    "id": "G056 M0112 C00005 PG0027250",
    "cognome": "BELLUSCI",
    "nome": "Giuseppe Salvatore"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLE FINANZE",
    "idpersona": "PG0019540",
    "id": "G056 M0070 C00005 PG0019540",
    "cognome": "PELLA",
    "nome": "Giuseppe"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'ASSISTENZA POST-BELLICA",
    "idpersona": "PG0012800",
    "id": "G056 M0084 C00005 PG0012800",
    "cognome": "CACCIATORE",
    "nome": "Luigi"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA GUERRA",
    "idpersona": "PG0013110",
    "id": "G056 M0073 C00005 PG0013110",
    "cognome": "CHATRIAN",
    "nome": "Luigi"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO FINANZE E TESORO",
    "idpersona": "PG0019540",
    "id": "G057 M0107 C00005 PG0019540",
    "cognome": "PELLA",
    "nome": "Giuseppe"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DELLA GRAZIA E GIUSTIZIA",
    "idpersona": "PG0011230",
    "id": "G057 M0125 C00003 PG0011230",
    "cognome": "GULLO",
    "nome": "Fausto"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO AI TRASPORTI",
    "idpersona": "PG0018970",
    "id": "G056 M0115 C00005 PG0018970",
    "cognome": "JERVOLINO",
    "nome": "Angelo Raffaele"
  },
  {
    "governo": "G058",
    "ruolo": "PRESIDENTE DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0013230",
    "id": "G058 M0121 C00001 PG0013230",
    "cognome": "DE GASPERI",
    "nome": "Alcide"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DELLA MARINA MERCANTILE",
    "idpersona": "PG0025290",
    "id": "G056 M0120 C00003 PG0025290",
    "cognome": "ALDISIO",
    "nome": "Salvatore"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DEL LAVORO E PREVIDENZA SOCIALE",
    "idpersona": "PG0026830",
    "id": "G057 M0099 C00003 PG0026830",
    "cognome": "ROMITA",
    "nome": "Giuseppe"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO SENZA PORTAFOGLIO DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0019410",
    "id": "G056 M0121 C00006 PG0019410",
    "cognome": "NENNI",
    "nome": "Pietro"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO AL COMMERCIO CON L'ESTERO",
    "idpersona": "PG0006510",
    "id": "G057 M0100 C00005 PG0006510",
    "cognome": "ASSENNATO",
    "nome": "Mario"
  },
  {
    "governo": "G055",
    "ruolo": "PRESIDENTE DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0013230",
    "id": "G055 M0121 C00001 PG0013230",
    "cognome": "DE GASPERI",
    "nome": "Alcide"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO AI LAVORI PUBBLICI",
    "idpersona": "PG0028410",
    "id": "G056 M0113 C00005 PG0028410",
    "cognome": "RESTAGNO",
    "nome": "Pier Carlo"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DELLA MARINA MERCANTILE",
    "idpersona": "PG0025290",
    "id": "G057 M0120 C00003 PG0025290",
    "cognome": "ALDISIO",
    "nome": "Salvatore"
  },
  {
    "governo": "G058",
    "ruolo": "ALTO COMMISSARIO AGGIUNTO PER L'IGIENE E LA SANITA' PUBBLICA",
    "idpersona": "PG0027730",
    "id": "G058 M0145 C00032 PG0027730",
    "cognome": "D'AMICO",
    "nome": "Diego"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA PRESIDENZA DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0009480",
    "id": "G057 M0121 C00005 PG0009480",
    "cognome": "MOSCATELLI",
    "nome": "Vincenzo"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELL'INTERNO",
    "idpersona": "PG0019990",
    "id": "G058 M0123 C00003 PG0019990",
    "cognome": "SCELBA",
    "nome": "Mario"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELL'AGRICOLTURA E FORESTE",
    "idpersona": "PG0026930",
    "id": "G058 M0078 C00003 PG0026930",
    "cognome": "SEGNI",
    "nome": "Antonio"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELLA PUBBLICA ISTRUZIONE",
    "idpersona": "PG0018910",
    "id": "G058 M0112 C00003 PG0018910",
    "cognome": "GONELLA",
    "nome": "Guido"
  },
  {
    "governo": "G056",
    "ruolo": "PRESIDENTE DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0013230",
    "id": "G056 M0121 C00001 PG0013230",
    "cognome": "DE GASPERI",
    "nome": "Alcide"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA GRAZIA E GIUSTIZIA",
    "idpersona": "PG0028170",
    "id": "G057 M0125 C00005 PG0028170",
    "cognome": "MERLIN",
    "nome": "Umberto"
  },
  {
    "governo": "G056",
    "ruolo": "ALTO COMMISSARIO PER L'ALIMENTAZIONE",
    "idpersona": "PG0025290",
    "id": "G056 M0149 C00031 PG0025290",
    "cognome": "ALDISIO",
    "nome": "Salvatore"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLE FINANZE",
    "idpersona": "PG0012490",
    "id": "G058 M0109 C00005 PG0012490",
    "cognome": "MALVESTITI",
    "nome": "Piero"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DEI TRASPORTI",
    "idpersona": "PG0027860",
    "id": "G057 M0115 C00003 PG0027860",
    "cognome": "FERRARI",
    "nome": "Giacomo"
  },
  {
    "governo": "G058",
    "ruolo": "ALTO COMMISSARIO PER L'ALIMENTAZIONE",
    "idpersona": "PG0300656",
    "id": "G058 M0149 C00031 PG0300656",
    "cognome": "RONCHI",
    "nome": "Vittorio"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO FINANZE E TESORO",
    "idpersona": "PG0027400",
    "id": "G057 M0107 C00005 PG0027400",
    "cognome": "BRASCHI",
    "nome": "Giovanni"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'INDUSTRIA E COMMERCIO",
    "idpersona": "PG0025830",
    "id": "G057 M0117 C00005 PG0025830",
    "cognome": "FARALLI",
    "nome": "Vannuccio"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DELL'AGRICOLTURA E FORESTE",
    "idpersona": "PG0026930",
    "id": "G056 M0078 C00003 PG0026930",
    "cognome": "SEGNI",
    "nome": "Antonio"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA PRESIDENZA DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0200021",
    "id": "G058 M0121 C00027 PG0200021",
    "cognome": "ANDREOTTI",
    "nome": "Giulio"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DELL'AERONAUTICA",
    "idpersona": "PG0027610",
    "id": "G056 M0075 C00003 PG0027610",
    "cognome": "CINGOLANI",
    "nome": "Mario"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO SENZA PORTAFOGLIO DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0026250",
    "id": "G056 M0121 C00006 PG0026250",
    "cognome": "MACRELLI",
    "nome": "Cino"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO AL LAVORO E PREVIDENZA SOCIALE",
    "idpersona": "PG0018290",
    "id": "G056 M0099 C00005 PG0018290",
    "cognome": "CASSIANI",
    "nome": "Gennaro"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO AL TESORO",
    "idpersona": "PG0012150",
    "id": "G058 M0110 C00005 PG0012150",
    "cognome": "PETRILLI",
    "nome": "Raffaele Pio"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DELLA MARINA MILITARE",
    "idpersona": "PG0026450",
    "id": "G056 M0151 C00003 PG0026450",
    "cognome": "MICHELI",
    "nome": "Giuseppe"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO AI LAVORI PUBBLICI",
    "idpersona": "PG0028410",
    "id": "G057 M0113 C00005 PG0028410",
    "cognome": "RESTAGNO",
    "nome": "Pier Carlo"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLE FINANZE",
    "idpersona": "PG0011760",
    "id": "G056 M0070 C00005 PG0011760",
    "cognome": "SCOCA",
    "nome": "Salvatore"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO AI TRASPORTI",
    "idpersona": "PG0018970",
    "id": "G057 M0115 C00005 PG0018970",
    "cognome": "JERVOLINO",
    "nome": "Angelo Raffaele"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DEL COMMERCIO CON L'ESTERO",
    "idpersona": "PG0300646",
    "id": "G058 M0100 C00003 PG0300646",
    "cognome": "MERZAGORA",
    "nome": "Cesare"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'INTERNO",
    "idpersona": "PG0026300",
    "id": "G058 M0123 C00005 PG0026300",
    "cognome": "MARAZZA",
    "nome": "Achille"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DELL'INTERNO",
    "idpersona": "PG0019990",
    "id": "G057 M0123 C00003 PG0019990",
    "cognome": "SCELBA",
    "nome": "Mario"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO AGLI AFFARI ESTERI",
    "idpersona": "PG0018060",
    "id": "G058 M0122 C00005 PG0018060",
    "cognome": "BRUSASCA",
    "nome": "Giuseppe"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DEI LAVORI PUBBLICI",
    "idpersona": "PG0028590",
    "id": "G058 M0113 C00003 PG0028590",
    "cognome": "TUPINI",
    "nome": "Umberto"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'INTERNO",
    "idpersona": "PG0013130",
    "id": "G056 M0123 C00005 PG0013130",
    "cognome": "CORSI",
    "nome": "Angelo"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DELLA GRAZIA E GIUSTIZIA",
    "idpersona": "PG0011230",
    "id": "G056 M0125 C00003 PG0011230",
    "cognome": "GULLO",
    "nome": "Fausto"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA GRAZIA E GIUSTIZIA",
    "idpersona": "PG0026300",
    "id": "G056 M0125 C00005 PG0026300",
    "cognome": "MARAZZA",
    "nome": "Achille"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'INDUSTRIA E COMMERCIO",
    "idpersona": "PG0025520",
    "id": "G058 M0117 C00005 PG0025520",
    "cognome": "CAVALLI",
    "nome": "Antonio"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO AGLI AFFARI ESTERI",
    "idpersona": "PG0003520",
    "id": "G057 M0122 C00005 PG0003520",
    "cognome": "LUPIS",
    "nome": "Giuseppe"
  },
  {
    "governo": "G058",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA PRESIDENZA DEL CONSIGLIO DEI MINISTRI",
    "idpersona": "PG0009080",
    "id": "G058 M0121 C00005 PG0009080",
    "cognome": "MARTINO",
    "nome": "Edoardo Angelo"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELL'INDUSTRIA E COMMERCIO",
    "idpersona": "PG0020170",
    "id": "G058 M0117 C00003 PG0020170",
    "cognome": "TOGNI",
    "nome": "Giuseppe"
  },
  {
    "governo": "G057",
    "ruolo": "MINISTRO DEI LAVORI PUBBLICI",
    "idpersona": "PG0010380",
    "id": "G057 M0113 C00003 PG0010380",
    "cognome": "SERENI",
    "nome": "Emilio"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELLA MARINA MERCANTILE",
    "idpersona": "PG0011350",
    "id": "G058 M0120 C00003 PG0011350",
    "cognome": "CAPPA",
    "nome": "Paolo"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DELLE FINANZE",
    "idpersona": "PG0028480",
    "id": "G056 M0070 C00003 PG0028480",
    "cognome": "SCOCCIMARRO",
    "nome": "Mauro"
  },
  {
    "governo": "G058",
    "ruolo": "MINISTRO DELLE POSTE E TELECOMUNICAZIONI",
    "idpersona": "PG0028170",
    "id": "G058 M0116 C00003 PG0028170",
    "cognome": "MERLIN",
    "nome": "Umberto"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DELLA PUBBLICA ISTRUZIONE",
    "idpersona": "PG0018910",
    "id": "G056 M0112 C00003 PG0018910",
    "cognome": "GONELLA",
    "nome": "Guido"
  },
  {
    "governo": "G056",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLA GUERRA",
    "idpersona": "PG0009090",
    "id": "G056 M0073 C00005 PG0009090",
    "cognome": "MARTINO",
    "nome": "Enrico"
  },
  {
    "governo": "G056",
    "ruolo": "ALTO COMMISSARIO AGGIUNTO PER L'ALIMENTAZIONE",
    "idpersona": "PG0026890",
    "id": "G056 M0149 C00032 PG0026890",
    "cognome": "SANSONE",
    "nome": "Luigi Renato"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALL'AGRICOLTURA E FORESTE",
    "idpersona": "PG0012180",
    "id": "G057 M0078 C00005 PG0012180",
    "cognome": "DE FILPO",
    "nome": "Luigi"
  },
  {
    "governo": "G057",
    "ruolo": "SOTTOSEGRETARIO DI STATO ALLE POSTE E TELECOMUNICAZIONI",
    "idpersona": "PG0012440",
    "id": "G057 M0116 C00005 PG0012440",
    "cognome": "GALATI",
    "nome": "Vito Giuseppe"
  },
  {
    "governo": "G056",
    "ruolo": "MINISTRO DEL LAVORO E PREVIDENZA SOCIALE",
    "idpersona": "PG0027740",
    "id": "G056 M0099 C00003 PG0027740",
    "cognome": "D'ARAGONA",
    "nome": "Lodovico"
  }
]
];
